import React from "react";
import { withRouter, Link } from "react-router-dom";
import Select from "react-select";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from '@mui/material/Checkbox';
import { BsCircle, BsCheckCircleFill, BsInfoCircle } from "react-icons/bs";
import axios from "axios";

import nielit_logo from "../assets/nielit_logo.png";
import ic_logo from "../assets/ic_logo.png";
import startup_nl from "../assets/startup_nl.png";
import meity_logo from "../assets/meity_logo.png";
import "./forms.css";
import "react-toastify/dist/ReactToastify.css";

const districtOptions = [
  { value: "Chümoukedima", label: "Chümoukedima" },
  { value: "Dimapur", label: "Dimapur" },
  { value: "Kiphire", label: "Kiphire" },
  { value: "Kohima", label: "Kohima" },
  { value: "Longleng", label: "Longleng" },
  { value: "Mokokchung", label: "Mokokchung" },
  { value: "Mon", label: "Mon" },
  { value: "Niuland", label: "Niuland" },
  { value: "Noklak", label: "Noklak" },
  { value: "Peren", label: "Peren" },
  { value: "Phek", label: "Phek" },
  { value: "Shamator", label: "Shamator" },
  { value: "Tuensang", label: "Tuensang" },
  { value: "Tseminyü", label: "Tseminyü" },
  { value: "Wokha ", label: "Wokha " },
  { value: "Zünheboto", label: "Zünheboto" }
];

const sectorOptions = [
  { value: "Agriculture, Food, Dairy", label: "Agriculture, Food, Dairy" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Education", label: "Education" },
  { value: "Housing", label: "Housing" },
  { value: "Technology & Development", label: "Technology & Development" },
  { value: "Handicrafts", label: "Handicrafts" },
  { value: "Water & Sanitation", label: "Water & Sanitation" },
  { value: "Microfinance/ Finance Inclusion", label: "Microfinance/ Finance Inclusion" },
  { value: "Energy", label: "Energy" },
  { value: "IT Sector", label: "IT Sector" },
  { value: "Travel, Tourism, Hospitality", label: "Travel, Tourism, Hospitality" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Logistics", label: "Logistics" },
  { value: "Packaging", label: "Packaging" },
  { value: "Waste Management", label: "Waste Management" },
  { value: "Chemicals", label: "Chemicals" },
  { value: "Refinery, Oil Field Services", label: "Refinery, Oil Field Services" },
  { value: "Others", label: "Others" }
];

const structureOptions = [
  { value: "Not for Profit", label: "Not for Profit" },
  { value: "Private Limited", label: "Private Limited" },
  { value: "Partnership", label: "Partnership" },
  { value: "Proprietorship", label: "Proprietorship" },
  { value: "Not yet registered (Entrepreneur)", label: "Not yet registered (Entrepreneur)" }
];

const styles = {
  row: {
      marginLeft: 0,
      marginRight: 0
  },
  col: {
      paddingLeft: 0,
      paddingRight: 0
  }
};

class registration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      switchView: true,
      foundersName: "",
      cofoundersName:"",
      startupName: "",
      phone: "",
      email: "",
      year: "",
      district: "",
      sector: "",
      structure: "",
      purpose: "",
      problem: "",
      errors: {},
      isIndian: false,
      isRegisteredInNagaland: false,
      isPermanentResident: false,
      isLocalWorkforce: false,
      gender: "Male"
    };
    this.handleFoundersName = this.handleFoundersName.bind(this);
    this.handleStartupName = this.handleStartupName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleYear = this.handleYear.bind(this);
    this.handlePurpose = this.handlePurpose.bind(this);
    this.handleProblem = this.handleProblem.bind(this);
  }
  handleFoundersName = async (event) => {
    let errors = this.state.errors;
    let foundersName = event.target.value.length
    if (foundersName>1) {
      errors["foundersName"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["foundersName"] = "Enter a valid name";
      this.setState({ errors: errors});
    }
    this.setState({
      foundersName: event.target.value,
    });
  }
  handleCoFoundersName = async (event) => {
    this.setState({
      cofoundersName: event.target.value,
    });
  }
  handleStartupName = async (event) => {
    let errors = this.state.errors;
    let startupName = event.target.value.length
    if (startupName>0) {
      errors["startupName"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["startupName"] = "Cannot be empty";
      this.setState({ errors: errors});
    }
    this.setState({
      startupName: event.target.value,
    });
  }
  handlePhone = async (object) => {
    if (object.target.value.length <= object.target.maxLength) {
      this.setState({ phone: object.target.value });
    }
    let errors = this.state.errors;
    var phoneLength = object.target.value.length;
    if (phoneLength === 11 || phoneLength === 10 ) {
      errors["phone"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["phone"] = "Must be 10 digits";
      this.setState({ errors: errors});
    }
  }
  handleEmail(event) {
    var re = /\S+@\S+\.\S+/;
    var result = re.test(event.target.value);
    let errors = this.state.errors;
    if(re.test(event.target.value))
    {
      errors["email"] = null
      this.setState({ errors: errors});
      console.log(result)
    }
    else{
      errors["email"] = "Invalid Email";
      this.setState({ errors: errors });
    }
    this.setState({
      email: event.target.value,
    });
  }
  handleYear = async (object) => {
    if (object.target.value.length <= object.target.maxLength) {
      this.setState({ year: object.target.value });
    }
    let errors = this.state.errors;
    var yearLength = object.target.value.length;
    if (yearLength === 5 || yearLength === 4 ) {
      errors["year"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["year"] = "Invalid Year";
      this.setState({ errors: errors});
    }
  }
  handleDistrict = (district) => {
    this.setState({ district: district.value });
    let errors = this.state.errors;
    if (this.state.district != null || district.value) {
      errors["district"] = null
      this.setState({ errors: errors });
    } else {
      errors["district"] = "Select a district";
      this.setState({ errors: errors });
    }
  };
  handleSector = (sector) => {
    this.setState({ sector: sector.value });
    let errors = this.state.errors;
    if (this.state.district != null || sector.value) {
      errors["sector"] = null
      this.setState({ errors: errors });
    } else {
      errors["sector"] = "Select a sector";
      this.setState({ errors: errors });
    }
  };
  handleStructure = (structure) => {
    this.setState({ structure: structure.value });
    let errors = this.state.errors;
    if (this.state.district != null || structure.value) {
      errors["structure"] = null
      this.setState({ errors: errors });
    } else {
      errors["structure"] = "Select a business structure";
      this.setState({ errors: errors });
    }
  };
  handlePurpose(event) {
    let errors = this.state.errors;
    let message = event.target.value.length
    if (message>30) {
      errors["purpose"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["purpose"] = "Must be at least 30 characters";
      this.setState({ errors: errors});
    }
    this.setState({ purpose: event.target.value });
  }
  handleProblem(event) {
    let errors = this.state.errors;
    let message = event.target.value.length
    if (message>30) {
      errors["problem"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["problem"] = "Must be at least 30 characters";
      this.setState({ errors: errors});
    }
    this.setState({ problem: event.target.value });
  }
  checkSubmit = () => {
    const {foundersName, phone, email, startupName, year, district, sector, structure, purpose, problem, errors} = this.state;
    let nameWarning = this.state.errors["foundersName"];
    let phoneWarning = this.state.errors["phone"];
    let emailWarning = this.state.errors["email"];
    let startupNameWarning = this.state.errors["startupName"];
    let yearWarning = this.state.errors["year"];
    let districtWarning = this.state.errors["district"];
    let sectorWarning = this.state.errors["sector"];
    let structureWarning = this.state.errors["structure"];
    let purposeWarning = this.state.errors["purpose"];
    let problemWarning = this.state.errors["problem"];
    if(foundersName != "" && phone != "" && email != "" && startupName != "" && year != "" && district != "" && sector != "" && structure != "" && purpose != "" && problem != ""){
      if(emailWarning == null && nameWarning == null && phoneWarning == null && startupNameWarning == null && yearWarning == null && districtWarning == null && sectorWarning == null&& structureWarning == null&& purposeWarning == null&& problemWarning == null)
      {
        this.toastFunct()
        this.submitData()
      }
      
    }
    else{
      this.warnToast()
      console.log("INVALID")
    }
  }
  toastFunct() {
    toast.info("Sending ..", {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  warnToast() {
    toast.warn("Form Data Invalid", {
      position: "bottom-center",
      autoClose: 2700,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  submitData = async() => {
    const {foundersName, cofoundersName, phone, email, startupName, year, district, sector, structure, purpose, problem, isRegisteredInNagaland, isLocalWorkforce, isPermanentResident, gender, errors} = this.state;
    let apiUrl = "https://nielit-startup.cybersecnielit.in/api/add_details.php"
    let formData = new FormData();
    formData.append("founders_name", foundersName);
    formData.append("co_founders_name", cofoundersName);
    formData.append("startup_name", startupName);
    formData.append("contact_no", phone);
    formData.append("email", email);
    formData.append("year_of_establishment", year);
    formData.append("district", district);
    formData.append("sector", sector);
    formData.append("business_structure", structure);
    formData.append("purpose", purpose);
    formData.append("problem_addressing", problem);
    formData.append("is_permanent_resident_of_nagaland", isPermanentResident ? "Yes" : "No");
    formData.append("is_business_reg_in_nagaland", isRegisteredInNagaland ? "Yes" : "No");
    formData.append("is_local_workforce", isLocalWorkforce ? "Yes" : "No");
    formData.append("gender", gender);
    console.log(formData);
    await axios({
      method: "post",
      url: apiUrl,
      data: formData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .then((response) => {
      console.log(response);
      toast.success('Form Submitted', {
        position: "bottom-center",
        autoClose: 2200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setTimeout( () => {
        window.location.reload();
      }, 2700);
    })
    .catch(function (response) {
      console.log(response);
    });
  }
  
  render() {
    const { district, sector, structure, isIndian, isLocalWorkforce, isPermanentResident, isRegisteredInNagaland, gender } = this.state;
    return (
      <div className="container-box">
        <div className="logos-div-navbar">
          <img
            alt="logo"
            src={nielit_logo}
            className="nielit-logo-navbar"
          />
          <img
            alt="logo"
            src={startup_nl}
            className="nl-logo-navbar"
          />
          <img
            alt="logo"
            src={ic_logo}
            className="handloom-logo-navbar"
          />
          <img
            alt="logo"
            src={meity_logo}
            className="meity-logo-navbar"
          />
        </div>
        <div className="intro_div_form">
            <div className="intro_div_form_inner">
                <p className="intro_div_form_txt">TECHNOVATE 3.0</p>
                <p className="intro_div_form_subtxt">Think, Visualise, Realise</p>
                <p className="intro_div_form_description">A startup competition presented by NIELIT Kohima, in association with StartUp Nagaland, Department of Industries & Commerce (Goverment of Nagaland) and MeitY, Goverment of India.</p>
                <button className="requestQuote">
                  <a className="href_reports" href="#main">Get Started</a>
                </button>
            </div>
        </div>
        <div id="main">
          <Row className="form">
            <Col md={9} sm={12} xs={12}>
              <div className="form_mainDiv">
                <p className="home_box_1_title_white">Startup Details</p>
                <p className="home_box_1_para_white">Make sure you fill up the form only once with complete & correct details.</p>
                <div>
                  <Row>
                    <Col md={6} xs={12} sm={12}>
                      <p className="inputHeaderTxt">Founder's Name *</p>
                      <input
                          className="createOrderInputFull"
                          type="text"
                          placeholder="Enter founder's name (Eg: John Brown)"
                          onFocus={(e) => {this.handleFoundersName(e)}}
                          onChange={(e) => {this.handleFoundersName(e)}}
                          value={this.state.foundersName}
                      />
                      {
                        this.state.errors["foundersName"] ?
                          <span
                            className="validateErrorTxt"
                          >
                            {this.state.errors["foundersName"]}
                          </span>
                          :
                          <></>
                      }
                    </Col>
                    <Col md={6} xs={12} sm={12}>
                      <p className="inputHeaderTxt">Founder's Gender*</p>
                      <Row>
                        <Col md={6} xs={6} sm={6}>
                          <div className="checkboxes_gender">
                            <Checkbox
                                checked={gender == "Male" ? true : false}
                                onChange={() => this.setState({gender: "Male"})}
                                icon={<BsCircle size={20} className="chbk-icons"/>}
                                checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                            />
                            <span className="newDemo-radio-txt">Male</span>
                          </div>
                        </Col>
                        <Col md={6} xs={6} sm={6}>
                          <div className="checkboxes_gender">
                            <Checkbox
                                checked={gender == "Female" ? true : false}
                                onChange={() => this.setState({gender: "Female"})}
                                icon={<BsCircle size={20} className="chbk-icons"/>}
                                checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                            />
                            <span className="newDemo-radio-txt">Female</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <p className="inputHeaderTxt">Co-Founder's Name (optional)</p>
                  <input
                      className="createOrderInputFull"
                      type="text"
                      placeholder="Eg: John, Bill, Harry"
                      onFocus={(e) => {this.handleCoFoundersName(e)}}
                      onChange={(e) => {this.handleCoFoundersName(e)}}
                      value={this.state.cofoundersName}
                  />
                  <Row>
                    <Col md={6} sm={12} xs={12}>
                      <p className="inputHeaderTxt">Phone Number *</p>
                      <input
                          className="createOrderInputLeft"
                          type = "number" maxLength = "10"
                          placeholder="Enter your phone number"
                          value={this.state.phone}
                          onChange={this.handlePhone}
                          onFocus={this.handlePhone}
                          
                      />
                      {
                        this.state.errors["phone"] ?
                          <span
                            className="validateErrorTxt"
                          >
                            {this.state.errors["phone"]}
                          </span>
                          :
                          <></>
                      }
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                      <p className="inputHeaderTxt">Email ID *</p>
                      <input
                          className="createOrderInputRight"
                          type="text"
                          value={this.state.email}
                          placeholder="Enter your email ID"
                          onChange={this.handleEmail}
                          onFocus={this.handleEmail}
                      />
                      {
                        this.state.errors["email"] ?
                          <span
                            className="validateErrorTxtRight"
                          >
                            {this.state.errors["email"]}
                          </span>
                          :
                          <></>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} sm={12} xs={12}>
                      <p className="inputHeaderTxt">Startup Name *</p>
                      <input
                          className="createOrderInputLeft"
                          type="text"
                          placeholder="Enter your startup name"
                          onFocus={this.handleStartupName}
                          onChange={this.handleStartupName}
                          value={this.state.star}
                      />
                      {
                        this.state.errors["startupName"] ?
                          <span
                            className="validateErrorTxt"
                          >
                            {this.state.errors["startupName"]}
                          </span>
                          :
                          <></>
                      }
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                      <p className="inputHeaderTxt">Year of Establishment *</p>
                      <input
                          className="createOrderInputRight"
                          type = "number" maxLength = "4"
                          placeholder="Enter year of establishment"
                          value={this.state.year}
                          onChange={this.handleYear}
                          onFocus={this.handleYear}
                      />
                      {
                        this.state.errors["year"] ?
                          <span
                            className="validateErrorTxtRight"
                          >
                            {this.state.errors["year"]}
                          </span>
                          :
                          <></>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} sm={12} xs={12}>
                      <p className="inputHeaderTxt">District *</p>
                      <Select
                        onFocus={this.handleDistrict}
                        onChange={this.handleDistrict}
                        value={districtOptions.find(
                          (item) => item.value === district
                        )}
                        options={districtOptions}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            height: 48,
                            borderRadius: 8,
                            width: "100%"
                          })
                        }}
                        placeholder={
                          <>
                            <div className="forPC">Select district</div>
                            <div className="forMobile">Select</div>
                          </>
                        }
                      />
                      {
                          this.state.errors["district"] ?
                            <span
                              className="validateErrorTxt"
                            >
                              {this.state.errors["district"]}
                            </span>
                            :
                            <></>
                        }
                    </Col>
                    <Col md={6} sm={6} xs={6} className="forPC">
                      <p className="inputHeaderTxt">State *</p>
                      <input
                          className="createOrderInputDisabled"
                          type="text"
                          disabled={true}
                          value={"Nagaland"}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} sm={6} xs={6}>
                      <p className="inputHeaderTxt">Sector *</p>
                      <Select
                        onFocus={this.handleSector}
                        onChange={this.handleSector}
                        value={sectorOptions.find(
                          (item) => item.value === sector
                        )}
                        options={sectorOptions}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            height: 48,
                            borderRadius: 8,
                            width: "100%"
                          })
                        }}
                        placeholder={
                          <>
                            <div className="forPC">Select sector</div>
                            <div className="forMobile">Select</div>
                          </>
                        }
                      />
                      {
                          this.state.errors["sector"] ?
                            <span
                              className="validateErrorTxt" id="marginsInput"
                            >
                              {this.state.errors["sector"]}
                            </span>
                            :
                            <></>
                        }
                    </Col>
                    <Col md={6} sm={6} xs={6}>
                      <p className="inputHeaderTxt">Business Structure *</p>
                      <Select
                        onFocus={this.handleStructure}
                        onChange={this.handleStructure}
                        value={structureOptions.find(
                          (item) => item.value === structure
                        )}
                        options={structureOptions}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            height: 48,
                            borderRadius: 8,
                            width: "100%",
                          })
                        }}
                        placeholder={
                          <>
                            <div className="forPC">Select  your business structure</div>
                            <div className="forMobile">Select</div>
                          </>
                        }
                      />
                      {
                          this.state.errors["structure"] ?
                            <span
                              className="validateErrorTxtRight" id="marginsInput"
                            >
                              {this.state.errors["structure"]}
                            </span>
                            :
                            <></>
                        }
                    </Col>
                  </Row>
                  <p className="inputHeaderTxt">What is the purpose of your idea? *</p>
                  <textarea
                    className="input-new-contact-message"
                    type="text"
                    placeholder="Describe briefly"
                    rows="4"
                    value={this.state.purpose}
                    onFocus={this.handlePurpose}
                    onChange={this.handlePurpose}
                  />
                  {
                    this.state.errors["purpose"] ?
                      <span
                        className="validateErrorTxt"
                      >
                        {this.state.errors["purpose"]}
                      </span>
                      :
                      <></>
                  }
                  <p className="inputHeaderTxt">What problem you are addressing? *</p>
                  <textarea
                    className="input-new-contact-message"
                    type="text"
                    placeholder="Describe briefly"
                    rows="4"
                    value={this.state.problem}
                    onFocus={this.handleProblem}
                    onChange={this.handleProblem}
                  />
                  {
                    this.state.errors["problem"] ?
                      <span
                        className="validateErrorTxt"
                      >
                        {this.state.errors["problem"]}
                      </span>
                      :
                      <></>
                  }
                  <div className="checkboxes_first">
                    <Checkbox
                        checked={isIndian}
                        onChange={() => this.setState({isIndian: !this.state.isIndian})}
                        icon={<BsCircle size={20} className="chbk-icons"/>}
                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                    />
                    <span className="newDemo-radio-txt">Are you an Indian citizen?</span>
                  </div>
                  <div className="checkboxes">
                    <Checkbox
                        checked={isPermanentResident}
                        onChange={() => this.setState({isPermanentResident: !this.state.isPermanentResident, isIndian: true})}
                        icon={<BsCircle size={20} className="chbk-icons"/>}
                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                    />
                    <span className="newDemo-radio-txt">Are you a Permanent Resident of Nagaland?</span>
                  </div>
                  <div className="checkboxes">
                    <Checkbox
                        checked={isRegisteredInNagaland}
                        onChange={() => this.setState({isRegisteredInNagaland: !this.state.isRegisteredInNagaland})}
                        icon={<BsCircle size={20} className="chbk-icons"/>}
                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                    />
                    <span className="newDemo-radio-txt">Is your	business registered in Nagaland?</span>
                  </div>
                  <div className="checkboxes">
                    <Checkbox
                        checked={isLocalWorkforce}
                        onChange={() => this.setState({isLocalWorkforce: !this.state.isLocalWorkforce})}
                        icon={<BsCircle size={20} className="chbk-icons"/>}
                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                    />
                    <span className="newDemo-radio-txt">Does your business employs at least 60% of its total workforce from	Indigenous Inhabitants of Nagaland?</span>
                  </div>
                  <center>
                    {
                      isIndian ?
                      <>
                        {
                          isLocalWorkforce || isPermanentResident || isRegisteredInNagaland ?
                            <button className="submitData" onClick={this.checkSubmit}>
                                Submit
                            </button>
                          :
                            <button className="submitData_disabled" onClick={this.checkSubmit}>
                                Submit
                            </button>
                        }
                      </>
                      :
                      <button className="submitData_disabled" onClick={this.checkSubmit}>
                          Submit
                      </button>
                    }
                  </center>
                </div>
              </div>
            </Col>
            <Col md={3} XS={12} SM={12}>
              <div className="registration_right">
                  <p className="login_header_text"><BsInfoCircle size={25}/> Instructions</p>
                  <ul>
                    <li><p className="passport_subheader_text">All fields marked with * are mandatory</p></li>
                    <li><p className="passport_subheader_text">The applicant must be a citizen of India.</p></li>
                    <li><p className="passport_subheader_text">The applicant must be a permanent resident of Nagaland or the business is registered in Nagaland or employs atleast 60% of its total workforce from Indigenous Inhabitants of Nagaland.</p></li>
                    <li><p className="passport_subheader_text">The applicant should have an idea in the IT domain with commercial viability.</p></li>
                    <li><p className="passport_subheader_text">Registration closes on 28th October 2023 at 11:59 PM.</p></li>
                    <li><p className="passport_subheader_text">Kindly recheck all the fields before submitting, as duplicate submissions will be rejected.</p></li>
                  </ul>
                </div>
            </Col>
          </Row>
        </div>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    )
  }
}
export default withRouter(registration);
